module.exports = __webpack_public_path__ + "img/townhome.b8f424eb.svg";